import { TooltipWrapper } from '@va/ui/tooltips';
import { useCheckOverflow } from '@va/util/hooks';
import { useRef } from 'react';

type ActionCardType = {
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  subTitle: string;
  title: string;
  linkTo?: string;
};

export const ActionCard = (props: ActionCardType) => {
  const { leftIcon, rightIcon, title, subTitle, linkTo } = props;
  const subTitleRef = useRef(null);
  const isOverflow = useCheckOverflow(subTitleRef);

  return (
    <a
      href={linkTo}
      rel='noreferrer'
      target='_blank'
      className='bg-white-snow p-3 mb-3 rounded-18 flex items-center justify-between hover:bg-white-smoke'
    >
      <div className='flex w-4/5'>
        <div className='h-12 min-w-[3rem] rounded-24 bg-white flex items-center justify-center'>{leftIcon}</div>

        <div className='ml-3 flex justify-center flex-col w-4/5 overflow-hidden'>
          <div className='text-xs text-devil-gray leading-18 font-medium'>{title}</div>
          <TooltipWrapper disabled={!isOverflow} content={subTitle} ref={subTitleRef}>
            <div className='text-sm text-gray-charcoal leading-24 font-medium truncate'>{subTitle}</div>
          </TooltipWrapper>
        </div>
      </div>
      <div className={'mr-3 cursor-pointer'}>{rightIcon}</div>
    </a>
  );
};
